<script>
export default {
    name: 'ContentQuoteBlock',
    props: {
        data: Object,
    },computed: {
        statement() {
            return this.data.statement.replace(/"(.*?)"/g, "«$1»");
        },
    },
};
</script>

<template>
    <div class="quote-block">
        <p class="quote-block__statement">{{ statement }}</p>
        <p class="quote-block__quotee" v-if="data.quotee">{{ data.quotee }}</p>
    </div>
</template>

<style lang="scss" scoped>
.quote-block {
    margin: 12rem $layout-off-grid-width * -1;

    @include breakpoint('sm-down') {
        margin: 12rem 0;
    }
}
.quote-block__statement {
    margin: 0 0 1.6rem;
    font-size: 4.8rem;
    font-weight: 700;
    font-style: italic;
    letter-spacing: 0.033rem;
    line-height: 1.1;

    @include breakpoint('sm-down') {
        font-size: 3.68rem;
    }
}
.quote-block__quotee {
    margin: 0;
    font-size: 1.8rem;
    color: $color-secondary;
    letter-spacing: 0.052rem;
}
</style>
